export function BattleTab() {
  return (
    <div className="p-6">
      <div className="marketing-panel-warm p-8 text-center max-w-md mx-auto">
        <div className="text-4xl mb-4">🏆</div>
        <h2 className="font-serif text-xl text-ink mb-2" style={{ fontWeight: 600 }}>
          Community is coming
        </h2>
        <p className="text-sm text-ink-muted mb-6" style={{ fontWeight: 300 }}>
          Soon you&apos;ll be able to compare scores with friends, join weekly challenges,
          and climb the leaderboard. For now, share your results directly.
        </p>
        <button
          onClick={() => {
            const url = `${window.location.origin}/?ref=community`;
            if (navigator.share) {
              navigator.share({ title: 'PhotoFeeler AI', text: 'Check out PhotoFeeler AI — it scores your dating and LinkedIn photos.', url }).catch(() => {});
            } else {
              navigator.clipboard.writeText(url).then(() => {
                // simple feedback
              });
            }
          }}
          className="btn-rose text-sm"
        >
          Share PhotoFeeler with a friend
        </button>
      </div>
    </div>
  );
}
